import React from 'react'
import { FormattedHTMLMessage, injectIntl } from 'react-intl'
import Translation from '../../../global/Translation'
import { ReactComponent as ShippingTruckIcon } from '../../../../assets/img/order-history/shipping-truck.svg'
import ProductImage from '../../../catalog/ProductImage'
import { addForwardSlash, getConfigLineName } from '../Utils'
import ProductDisplayName from '../../../global/ProductDisplayName'
import { OrderLineStatus } from '../Enums/OrderLineStatus'
import moment from 'moment'
import { ElaborationOptionsMapById } from '../../../cut-to-size/CutToSizeMaps'
import LineSegmentation from '../../../cart-line/LineSegmentation'
import { capitalizeFirstLetter } from '../../../../helpers'
import NaturalStoneIndicator from '../../../cart-line/indicators/NaturalStoneIndicator'
import CustomProductIndicator from '../../../cart-line/indicators/CustomProductIndicator'
import DisplayQuickShipIndicator from '../../../catalog/rectangleResult/displays/DisplayQuickShipIndicator'
import DisplayBrand from '../../../catalog/rectangleResult/displays/DisplayBrand'
import DisplayOutletIndicator from '../../../catalog/rectangleResult/displays/DisplayOutletIndicator'
import DisplayDiscontinued from '../../../catalog/rectangleResult/displays/DisplayDiscontinued'
import { canDisplayDiscontinued as baseCanDisplayDiscontinued } from '../../../../store/products/reducers'
import { getCenterDateRange } from '../../../../store/cart/reducers'

class NewOrderCardItem extends React.Component {
    render() {
        const { order, orderLine, orderStatusMap, intl, adaptedFormat, isIkeaCenter, redirect, replaceDotWithComma, locale, getMeasure } = this.props
        const centerDateRange = getCenterDateRange(orderLine.center_date)

        const showBtnToDetails = () => {
            if (order.orderId && order.reservationId && order.orderLines.length > 0 && !isIkeaCenter) return true
            return false
        }

        const handleBtnToDetailsOnClick = () => {
            redirect(
                intl
                    .formatMessage({ id: 'ROUTE_ORDER_DETAILS' })
                    .replace(':filter', 'view-order')
                    .replace(':reservationId', order.reservationId)
            )
        }

        const thicknessFormatIntl = orderLine => {
            if (!orderLine.product.thickness) return null
            return replaceDotWithComma(orderLine.product.thickness, locale) + ' cm'
        }

        const zaddonFormatIntl = orderLine => {
            if (orderLine.product.zaddon !== 'MAL') return null
            return intl.formatMessage({ id: 'MAL' })
        }

        const thicknessFormatCtsIntl = cts => {
            if (!cts.thickness) return null
            return replaceDotWithComma(cts.thickness, locale) + ' cm'
        }

        const finishFormatIntl = (orderLine, intl) => {
            if (!orderLine.product.finish) return null
            return intl.formatMessage({ id: orderLine.product.finish })
        }

        const finishFormatCtsInt = cts => {
            if (!cts.finish) return null
            return intl.formatMessage({ id: cts.finish })
        }

        const productFormatIntl = orderLine => {
            if (!orderLine.product.format) return null
            return adaptedFormat(orderLine.product.format, { upper: true, showUnits: true })
        }

        const subtypeFormatIntl = orderLine => {
            if (!orderLine.product.subtypeName) return null
            return intl.formatMessage({ id: orderLine.product.subtypeName })
        }

        const canDisplayDiscontinued = (product) => baseCanDisplayDiscontinued(
            product.webHeading,
            product.isProductDiscontinued,
            product.shouldShowDiscontinuedLabel
        )

        const validOrderLineStatus = orderLine && orderLine.status && orderLine.status.status ? orderLine.status.status : order.orderStatusV3.status
        const validOrderLineStatusDate = orderLine && orderLine.status && orderLine.status.date ? orderLine.status.date : order.orderStatusV3.date
        const isQuickShip = orderLine.isQuickShip || !!(orderLine.cut_to_size && orderLine.cut_to_size.configurable && orderLine.cut_to_size.configurable.thirdParty)

        const isNoPlannedDelivery = (
            validOrderLineStatusDate == null &&
            (
                validOrderLineStatus === OrderLineStatus.Created ||
                validOrderLineStatus === OrderLineStatus.Approved ||
                validOrderLineStatus === OrderLineStatus.Pending ||
                validOrderLineStatus === OrderLineStatus.In_process
            )
        )

        const hasCenterDeliveryMessage = isNoPlannedDelivery && !orderLine.cut_to_size

        const orderLinesStatusColor = () => {
            if (validOrderLineStatus === OrderLineStatus.Created) return '--position-created'
            if (validOrderLineStatus === OrderLineStatus.Approved) return '--position-confirmed'
            if (validOrderLineStatus === OrderLineStatus.Pending) return '--position-pending'
            if (validOrderLineStatus === OrderLineStatus.In_process) return '--position-in-process'
            if (validOrderLineStatus === OrderLineStatus.Partially_delivered) return '--position-partially-delivered'
            if (validOrderLineStatus === OrderLineStatus.Delivered) return '--position-delivered'
            if (validOrderLineStatus === OrderLineStatus.Order_cancelled) return '--position-cancelled'
        }

        const deliveryStatusLogic = () => {
            if (
                isQuickShip &&
                validOrderLineStatus != OrderLineStatus.Order_cancelled &&
                validOrderLineStatus != OrderLineStatus.Delivered &&
                validOrderLineStatus != OrderLineStatus.Partially_delivered
            ) {
                return (
                    <div className="shipping__status__info">
                        <div>
                            <span>
                                <FormattedHTMLMessage id="estimated_delivery_on_4_weeks" defaultMessage="Estimated delivery on <b>2-4 weeks</b>" />
                            </span>
                        </div>
                    </div>
                )
            }

            if (validOrderLineStatus === OrderLineStatus.Created && validOrderLineStatusDate == null) {
                if (hasCenterDeliveryMessage) return null
                return (
                    <div className="shipping__status__info">
                        <div>
                            <span>
                                <Translation id="no_planned_delivery" defaultMessage="No planned delivery" />
                            </span>
                        </div>
                    </div>
                )
            }

            if (validOrderLineStatus === OrderLineStatus.Created && validOrderLineStatusDate !== null) {
                return (
                    <div className="shipping__status__info">
                        <div>
                            <span>
                                <Translation id="estimated_delivery" defaultMessage="Estimated delivery" />
                            </span>
                            :&nbsp;
                            <span>
                                {moment(validOrderLineStatusDate).isSame(moment(), 'day') ? (
                                    <Translation id="today" defaultMessage="Today" />
                                ) : (
                                    moment(validOrderLineStatusDate).format('L')
                                )}
                            </span>
                        </div>
                    </div>
                )
            }

            if (validOrderLineStatus === OrderLineStatus.Approved && validOrderLineStatusDate == null) {
                if (hasCenterDeliveryMessage) return null
                return (
                    <div className="shipping__status__info">
                        <div>
                            <span>
                                <Translation id="no_planned_delivery" defaultMessage="No planned delivery" />
                            </span>
                        </div>
                    </div>
                )
            }

            if (validOrderLineStatus === OrderLineStatus.Approved && validOrderLineStatusDate !== null) {
                return (
                    <div className="shipping__status__info">
                        <div>
                            <span>
                                <Translation id="estimated_delivery" defaultMessage="Estimated delivery" />
                            </span>
                            :&nbsp;
                            <span>
                                {moment(validOrderLineStatusDate).isSame(moment(), 'day') ? (
                                    <Translation id="today" defaultMessage="Today" />
                                ) : (
                                    moment(validOrderLineStatusDate).format('L')
                                )}
                            </span>
                        </div>
                    </div>
                )
            }

            if (validOrderLineStatus === OrderLineStatus.Pending && validOrderLineStatusDate == null) {
                if (hasCenterDeliveryMessage) return null
                return (
                    <div className="shipping__status__info">
                        <div>
                            <span>
                                <Translation id="no_planned_delivery" defaultMessage="No planned delivery" />
                            </span>
                        </div>
                    </div>
                )
            }

            if (validOrderLineStatus === OrderLineStatus.Pending && validOrderLineStatusDate !== null) {
                return (
                    <div className="shipping__status__info">
                        <div>
                            <span>
                                <Translation id="estimated_delivery" defaultMessage="Estimated delivery" />
                            </span>
                            :&nbsp;
                            <span>
                                {moment(validOrderLineStatusDate).isSame(moment(), 'day') ? (
                                    <Translation id="today" defaultMessage="Today" />
                                ) : (
                                    moment(validOrderLineStatusDate).format('L')
                                )}
                            </span>
                        </div>
                    </div>
                )
            }

            if (validOrderLineStatus === OrderLineStatus.In_process && validOrderLineStatusDate == null) {
                if (hasCenterDeliveryMessage) return null
                return (
                    <div className="shipping__status__info">
                        <div>
                            <span>
                                <Translation id="no_planned_delivery" defaultMessage="No planned delivery" />
                            </span>
                        </div>
                    </div>
                )
            }

            if (validOrderLineStatus === OrderLineStatus.In_process && validOrderLineStatusDate !== null) {
                return (
                    <div className="shipping__status__info">
                        <div>
                            <span>
                                <Translation id="estimated_delivery" defaultMessage="Estimated delivery" />
                            </span>
                            :&nbsp;
                            <span>
                                {moment(validOrderLineStatusDate).isSame(moment(), 'day') ? (
                                    <Translation id="today" defaultMessage="Today" />
                                ) : (
                                    moment(validOrderLineStatusDate).format('L')
                                )}
                            </span>
                        </div>
                    </div>
                )
            }

            if (validOrderLineStatus === OrderLineStatus.Partially_delivered) {
                return (
                    <div className="shipping__status__info">
                        {showBtnToDetails() && (
                            <div className="subtitle">
                                <span>
                                    <Translation id="this_product_has_multiple_deliveries_check_deliveries_at" defaultMessage="This product has multiple deliveries. Check deliveries at" />
                                    &nbsp;
                                    <button onClick={() => handleBtnToDetailsOnClick()}>
                                        <Translation id="order_details" defaultMessage="Order details" />
                                    </button>
                                </span>
                            </div>
                        )}
                    </div>
                )
            }

            if (validOrderLineStatus === OrderLineStatus.Delivered && validOrderLineStatusDate == null) {
                return (
                    <div className="shipping__status__info">
                        <div>
                            <span>
                                <Translation id="entregado" defaultMessage="Delivered" />
                            </span>
                        </div>
                    </div>
                )
            }

            if (validOrderLineStatus === OrderLineStatus.Delivered && validOrderLineStatusDate !== null) {
                return (
                    <div className="shipping__status__info">
                        <div>
                            <span>
                                <Translation id="entregado" defaultMessage="Delivered" />
                            </span>
                            :&nbsp;
                            <span>
                                {moment(validOrderLineStatusDate).isSame(moment(), 'day') ? (
                                    <Translation id="today" defaultMessage="Today" />
                                ) : (
                                    moment(validOrderLineStatusDate).format('L')
                                )}
                            </span>
                        </div>
                    </div>
                )
            }

            if (validOrderLineStatus === OrderLineStatus.Order_cancelled && orderLine.reject_reason === 'D1') {
                return (
                    <div className="shipping__status__info">
                        <div>
                            <span>
                                <Translation id="product_canceled_by_user" defaultMessage="Product canceled by user" />
                            </span>
                        </div>
                    </div>
                )
            }

            if (validOrderLineStatus === OrderLineStatus.Order_cancelled && orderLine.reject_reason !== 'D1') {
                return (
                    <div className="shipping__status__info">
                        <div>
                            <span>
                                <Translation id="product_canceled_by_center" defaultMessage="Product cancelled by center" />
                            </span>
                        </div>
                    </div>
                )
            }
        }

        const deliveryDateCenterLogic = () => {
            if (!isNoPlannedDelivery) return null
            if (orderLine.cut_to_size) return null

            // Sin stock en center → tiene centerDate
            if (centerDateRange) {
                return (
                    <div className="shipping__status__info">
                        <span>
                            <Translation
                                id="center_delivery_date"
                                defaultMessage="Delivery of materials to your center between"
                            />:
                            <br></br>
                            {centerDateRange.start} <span className="and-separator">
                                <Translation id="and" defaultMessage="And" />
                            </span> {centerDateRange.end}
                        </span>
                    </div>
                )
            }

            // Con stock en center → no tiene centerDate
            return (
                <div className="shipping__status__info">
                    <span>
                        <Translation
                            id="stock_in_center_next_delivery"
                            defaultMessage="This material is available at our center. Delivery will be scheduled subject to quality/matching tone verification checks, and account conditions."
                        />
                    </span>
                </div>
            )
        }

        const positionStatus = (
            <div className="position__status">
                <div className={"position__status--shipping-icon " + orderLinesStatusColor()}>
                    <ShippingTruckIcon />
                </div>
                <div>
                    <span className={'position__status--text ' + orderLinesStatusColor()}>
                        {validOrderLineStatus
                            ? intl.formatMessage({ id: orderStatusMap[validOrderLineStatus].textToShow })
                            : intl.formatMessage({ id: orderStatusMap[order.orderStatusV3.status].textToShow })}
                    </span>
                </div>
            </div>
        )

        //Third column
        const deliveryStatusBlock = (
            <div className="shipping__status__content">
                <div className="shipping__status__content--elements">
                    <div>{positionStatus}</div>
                    <div>{deliveryStatusLogic()}</div>
                    <div>{deliveryDateCenterLogic()}</div>
                </div>
            </div>
        )

        //Second column
        const segmentationBlock = (
            <React.Fragment>
                {orderLine.segmentation && (
                    <div className="card__item__segmentation--desktop">
                        <LineSegmentation line={orderLine} showAsList />
                    </div>
                )}
            </React.Fragment>
        )

        const handleOrderLineQuantity = orderLine => {
            return (
                <React.Fragment>
                    {orderLine.reservation_quantity ? (
                        parseInt(orderLine.reservation_quantity) === 0 ? (
                            <Translation id="product_added_by_center" defaultMessage="Product added by center" />
                        ) : parseInt(orderLine.reservation_quantity) !== parseInt(orderLine.quantity) ? (
                            orderLine.quantity ? (
                                <React.Fragment>{parseInt(orderLine.quantity)}</React.Fragment>
                            ) : (
                                <Translation id="not_available" defaultMessage="Not available" />
                            )
                        ) : (
                            <React.Fragment>{parseInt(orderLine.reservation_quantity)}</React.Fragment>
                        )
                    ) : (
                        <Translation id="not_available" defaultMessage="Not available" />
                    )}
                </React.Fragment>
            )
        }

        const cutToSizeDescriptionBlock = orderLine => {
            const cts = orderLine.cut_to_size
            const measures = getMeasure(cts)
            const materialName = ElaborationOptionsMapById[orderLine.material_id]
                ? this.props.intl.formatMessage(ElaborationOptionsMapById[orderLine.material_id].name)
                : null
            const features = [materialName, measures.format, finishFormatCtsInt(cts), thicknessFormatCtsIntl(cts)]
            if (orderLine.cut_to_size.addon === 'MAL') features.push(this.props.intl.formatMessage({ id: 'MAL' }))

            return (
                <div>
                    <div className="order-divider-x"></div>
                    <div className="order__card__item order__card__item__grid">
                        {/* Firts column */}
                        <div className="card__item__productinfo">
                            <div className="card__item__productinfo--container">
                                <div className="card__item__productinfo--img">
                                    <img src={cts.thumb} alt="Cut to size" />
                                </div>
                                <div className="d-flex align-items-start flex-column" style={{ gap: '4px' }}>
                                    <CustomProductIndicator />
                                </div>
                            </div>
                            <div className="card__item__productinfo--text">
                                <div className="brand-container">
                                    <span className="brand">
                                        <DisplayBrand brand={cts.brand} />
                                    </span>
                                </div>

                                <div className="d-flex align-items-center flex-wrap" style={{ gap: '3px' }}>
                                    <div className="product">
                                        <span>{capitalizeFirstLetter(cts.colorName)}</span>
                                    </div>
                                    <div>
                                        <span className="technical">{addForwardSlash(...features)}</span>
                                    </div>
                                </div>

                                {orderLine.material_id && (
                                    <div className="product-id">
                                        <span>
                                            <Translation id="material_id" defaultMessage="Material ID" />
                                        </span>
                                        :&nbsp;
                                        <span>
                                            {orderLine.material_id}
                                        </span>
                                    </div>
                                )}

                                <div>
                                    <span className="qty">
                                        <Translation id="quantity" defaultMessage="Quantity" />
                                        :&nbsp;
                                        {handleOrderLineQuantity(orderLine)}
                                    </span>
                                </div>

                                {orderLine.segmentation && (
                                    <div className="card__item__segmentation--tablet">
                                        <LineSegmentation line={orderLine} showAsList />
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Second column */}
                        {segmentationBlock}

                        {/* Third column */}
                        {deliveryStatusBlock}
                    </div>
                </div>
            )
        }

        const descriptionBlock = orderLine => {
            return (
                <div>
                    <div className="order-divider-x"></div>
                    <div className="order__card__item order__card__item__grid">
                        {/* Firts column */}
                        <div className="card__item__productinfo">
                            <div className="card__item__productinfo--container">
                                <div className="card__item__productinfo--img">
                                    <ProductImage product={orderLine.product} inSmallBox={true} showEclosBrandLabel={false} />
                                </div>
                                <div className="d-flex align-items-start flex-column" style={{ gap: '4px' }}>
                                    {orderLine.extra && orderLine.extra.isCosentinoGlobal &&
                                        (orderLine.extra.outlet ? (
                                            <NaturalStoneIndicator idMessage={'outlet_in_hq'} defaultMessage="Outlet Spain" inSmallBox={true} />
                                        ) : (
                                            <NaturalStoneIndicator idMessage={'natural_stone_hq'} defaultMessage="Natural stone Spain" inSmallBox={true} />
                                        ))}

                                    {orderLine.extra && orderLine.extra.isCosentinoBrazil && (
                                        <NaturalStoneIndicator idMessage={'natural_stone_brazil'} defaultMessage="Natural stone Brazil" inSmallBox={true} />
                                    )}
                                </div>
                            </div>
                            <div className="card__item__productinfo--text">
                                <div className="brand-container">
                                    <span className="brand">
                                        <DisplayBrand brand={orderLine.product.brand} />
                                    </span>
                                </div>
                                <div className="d-flex align-items-center flex-wrap" style={{ gap: '3px' }}>
                                    <div>
                                        <span className="product">
                                            <ProductDisplayName product={orderLine.product} />
                                        </span>
                                    </div>
                                    <div>
                                        <span className="technical">
                                            {addForwardSlash(
                                                subtypeFormatIntl(orderLine),
                                                productFormatIntl(orderLine),
                                                finishFormatIntl(orderLine, intl),
                                                thicknessFormatIntl(orderLine),
                                                zaddonFormatIntl(orderLine)
                                            )}
                                        </span>
                                    </div>
                                </div>

                                {orderLine.product.productId && (
                                    <div className="product-id">
                                        <span>
                                            <Translation id="material_id" defaultMessage="Material ID" />
                                        </span>
                                        :&nbsp;
                                        <span>
                                            {orderLine.product.productId}
                                        </span>
                                    </div>
                                )}

                                {orderLine.lot_id && (
                                    <div className="lot-id">
                                        <span>
                                            <Translation id="lot_id" defaultMessage="Lot ID" />
                                            :&nbsp;
                                        </span>
                                        <span>{orderLine.lot_id}</span>
                                    </div>
                                )}

                                <div className="indicators-block">
                                    {orderLine.product.discontinued && (
                                        <span className="mb-1">
                                            <DisplayDiscontinued discontinued={canDisplayDiscontinued(orderLine.product)} inSmallBox={true} />
                                        </span>
                                    )}
                                    {orderLine.outlet_quality && (
                                        <span className="mb-1">
                                            <DisplayOutletIndicator
                                                outletQuality={orderLine.outlet_quality}
                                                inSmallBox={true}
                                            />
                                        </span>
                                    )}
                                </div>

                                <div>
                                    <span className="qty">
                                        <Translation id="quantity" defaultMessage="Quantity" />
                                        :&nbsp;
                                        {handleOrderLineQuantity(orderLine)}
                                    </span>
                                </div>

                                {orderLine.segmentation && (
                                    <div className="card__item__segmentation--tablet">
                                        <LineSegmentation line={orderLine} showAsList />
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Second column */}
                        {segmentationBlock}

                        {/* Third column */}
                        {deliveryStatusBlock}
                    </div>
                </div>
            )
        }

        const descriptionBlockConfigBath = orderLine => {
            const cts = orderLine.cut_to_size
            return (
                <div>
                    <div className="order-divider-x"></div>
                    <div className="order__card__item order__card__item__grid">
                        {/* Firts column */}
                        <div className="card__item__productinfo">
                            <div className="card__item__productinfo--container">
                                <div className="card__item__productinfo--img">
                                    {!!cts.configurable.thirdParty && <DisplayQuickShipIndicator tooltipId={cts.configurable.refcode} />}
                                    <img src={cts.thumb} alt={getConfigLineName(cts.configurable, intl)} className="is-img-configurable" />
                                </div>

                                <div className="d-flex align-items-start flex-column" style={{ gap: '4px' }}>
                                    <CustomProductIndicator />
                                </div>
                            </div>

                            <div className="card__item__productinfo--text">
                                <div className="brand-container">
                                    <span className="brand">
                                        <DisplayBrand brand={cts.configurable.material.brand} />
                                    </span>
                                </div>

                                <div className="d-flex align-items-center flex-wrap" style={{ gap: '3px' }}>
                                    <div>
                                        <span className="product">
                                            <span className="product-title">{getConfigLineName(cts.configurable, intl)}</span>
                                        </span>
                                    </div>
                                    <div>
                                        <span className="technical">
                                            <Translation id="customized" defaultMessage="Custom" />
                                        </span>
                                    </div>
                                </div>

                                {orderLine.material_id && (
                                    <div className="product-id">
                                        <span>
                                            <Translation id="material_id" defaultMessage="Material ID" />
                                        </span>
                                        :&nbsp;
                                        <span>
                                            {orderLine.material_id}
                                        </span>
                                    </div>
                                )}

                                <div>
                                    <span className="qty">
                                        <Translation id="quantity" defaultMessage="Quantity" />
                                        :&nbsp;
                                        {handleOrderLineQuantity(orderLine)}
                                    </span>
                                </div>

                                {orderLine.segmentation && (
                                    <div className="card__item__segmentation--tablet">
                                        <LineSegmentation line={orderLine} showAsList />
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Second column */}
                        {segmentationBlock}

                        {/* Third column */}
                        {deliveryStatusBlock}
                    </div>
                </div>
            )
        }

        return (
            <React.Fragment>
                {orderLine.product ? (
                    <React.Fragment>{descriptionBlock(orderLine)}</React.Fragment>
                ) : orderLine.cut_to_size && orderLine.cut_to_size.configurable ? (
                    <React.Fragment>{descriptionBlockConfigBath(orderLine)}</React.Fragment>
                ) : orderLine.cut_to_size ? (
                    <React.Fragment>{cutToSizeDescriptionBlock(orderLine)}</React.Fragment>
                ) : (
                    <div>
                        <div className="order-divider-x"></div>
                        <div className="order__card__item order__card__item__grid">
                            {/* First column */}
                            <div className="card__item__productinfo">
                                <div className="card__item__productinfo--img">
                                    <ProductImage product={null} />
                                </div>
                                <div className="card__item__productinfo--text">
                                    {orderLine.short_text && (
                                        <div>
                                            <span className="product">
                                                <span>{capitalizeFirstLetter(orderLine.short_text)}</span>
                                            </span>
                                        </div>
                                    )}
                                    {orderLine.material_id && (
                                        <div className="product-id">
                                            <span>
                                                <Translation id="material_id" defaultMessage="Material ID" />
                                            </span>
                                            :&nbsp;
                                            <span>
                                                {orderLine.material_id}
                                            </span>
                                        </div>
                                    )}

                                    {orderLine.lot_id && (
                                        <div className="lot-id">
                                            <span>
                                                <Translation id="lot_id" defaultMessage="Lot ID" />
                                                :&nbsp;
                                            </span>
                                            <span>{orderLine.lot_id}</span>
                                        </div>
                                    )}

                                    <div>
                                        <span className="qty">
                                            <Translation id="quantity" defaultMessage="Quantity" />
                                            :&nbsp;
                                            {handleOrderLineQuantity(orderLine)}
                                        </span>
                                    </div>

                                    {orderLine.segmentation && (
                                        <div className="card__item__segmentation--tablet">
                                            <LineSegmentation line={orderLine} showAsList />
                                        </div>
                                    )}
                                </div>
                            </div>
                            {/* Second column */}
                            {segmentationBlock}

                            {/* Third column */}
                            {deliveryStatusBlock}
                        </div>
                    </div>
                )}
            </React.Fragment>
        )
    }
}

export default injectIntl(NewOrderCardItem)
